import { Amplify } from 'aws-amplify';
import config from '@/config';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognitoPoolId ?? '',
        userPoolClientId: config.cognitoClientId ?? '',
        identityPoolId: config.cognitoIdentityPoolId ?? '',
        loginWith: {
          oauth: {
            domain: config.cognitoDomain ?? '',
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code',
          },
        },
      },
    },
  });
};
